module.exports = __webpack_public_path__ + "img/heitiane.3dde9a5c.png";